/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Icy_Many_Beaver_KickInputs */

const fr_icy_many_beaver_kick = /** @type {(inputs: Icy_Many_Beaver_KickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sécurité`)
};

/**

* @param {Icy_Many_Beaver_KickInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const icy_many_beaver_kick = /** @type {((inputs?: Icy_Many_Beaver_KickInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Icy_Many_Beaver_KickInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_icy_many_beaver_kick(inputs)
});